import { FilterableInterface } from './filterable.interface';

export class UserActivity implements FilterableInterface {

  constructor(
    public hash?: string,
    public name?: string,
    public erpTask?: string,
    public erpTaskName?: string,
    public typeCode?: number,
    public typeName?: string,
    public typeMachine?: boolean
  ) { }

  get filterableData() {
    return this.name.toLowerCase();
  }

  clone() {
    return new UserActivity (
      this.hash,
      this.name,
      this.erpTask,
      this.erpTaskName,
      this.typeCode,
      this.typeName,
      this.typeMachine
    );
  }

  get userActivityName() {
    return this.name;
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/user-activity.ts